import { render, staticRenderFns } from "./LinkFooter.vue?vue&type=template&id=3b5be3fd&scoped=true"
import script from "./LinkFooter.vue?vue&type=script&lang=js"
export * from "./LinkFooter.vue?vue&type=script&lang=js"
import style0 from "./LinkFooter.vue?vue&type=style&index=0&id=3b5be3fd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5be3fd",
  null
  
)

export default component.exports